/* eslint-disable react/jsx-handler-names */
import React, { useState } from 'react'
import { useLocation } from 'react-router'

import { SalesAssociatePasswordModal } from '../SalesAssociatePasswordModal'
import { SalesAssociatesModal } from '../SalesAssociatesModal'
import type { SalesAssociatesModal_salesAssociate$data } from '../SalesAssociatesModal/__generated__/SalesAssociatesModal_salesAssociate.graphql'
import { GoalsIframeModal } from './GoalsIframeModal'

export const GoalsAuthorizationModal = () => {
  const [selectedSalesAssociate, setSelectedSalesAssociate] = useState<
    SalesAssociatesModal_salesAssociate$data | null | undefined
  >(null)

  const location = useLocation()
  const isPasswordModalOpen = location.hash.includes(
    '#/sales-associate-password'
  )

  const [isPasswordMatched, setIsPasswordMatched] = useState(false)
  const handleSelectSalesAssociate = (
    salesAssociate: SalesAssociatesModal_salesAssociate$data | null | undefined
  ) => {
    setSelectedSalesAssociate(salesAssociate)
  }

  const handlePasswordSubmit = (matched: boolean) => {
    setIsPasswordMatched(matched)
  }

  return (
    <>
      <SalesAssociatesModal
        onSalesAssociateSelect={handleSelectSalesAssociate}
      />
      {selectedSalesAssociate && isPasswordModalOpen && (
        <SalesAssociatePasswordModal
          salesAssociate={selectedSalesAssociate}
          onPasswordSubmit={handlePasswordSubmit}
        />
      )}

      {selectedSalesAssociate && isPasswordMatched && (
        <GoalsIframeModal salesAssociateId={selectedSalesAssociate.id} />
      )}
    </>
  )
}
